import { render, staticRenderFns } from "./UjianSprint.vue?vue&type=template&id=81dd473c&scoped=true"
import script from "./UjianSprint.vue?vue&type=script&lang=js"
export * from "./UjianSprint.vue?vue&type=script&lang=js"
import style0 from "./UjianSprint.vue?vue&type=style&index=0&id=81dd473c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dd473c",
  null
  
)

export default component.exports